import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { IS_APP_LOADED } from "./reducers/appReducer";
import React from "react";
    
const SuspenceCallBack: React.FC<any> = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch({
        type: IS_APP_LOADED,
        isAploaded: true,
      });
    };
  }, []);
  return <div>Loading...</div>;
};

export default SuspenceCallBack;